<template>
  <div class="md:hidden">
    <div class="relative px-box-2 pt-12 bg-hero">
      <div class="flex flex-col items-center justify-center">
        <h1 class="relative title text-24 text-white mx-auto">
          {{ $t('app_prompt.hero_above_title') }}
        </h1>
        <AppImage />
      </div>
    </div>
    <div class="flex flex-col items-center justify-center pt-6">
      <a
        class="btn btn-amber w-4/5"
        :href="link"
        target="_blank"
        rel="nofollow noopener"
        @click="trackClick"
      >
        {{ $t('app_prompt.get_the_app') }}
      </a>
      <a class="pt-6 text-gray-500 font-semibold underline" href="#hero-search-form">
        {{ $t('app_prompt.continue_in_your_browser') }}
      </a>
    </div>
  </div>
</template>

<script lang="ts" setup>
import { AppPromptClick } from '@core/analytics/core-events/app'
import AppImage from './app-image-svg.vue'

const props = defineProps<{
  promptType: 'AboveHeroSearchForm_Country' | 'AboveHeroSearchForm_Home' | 'AboveHeroSearchForm_IMT'
}>()

const { $track } = useNuxtApp()
const link = useAppLink(`prompt_${props.promptType}`)

async function trackClick() {
  await $track(AppPromptClick(props.promptType))
}
</script>
